import { cn } from "@/lib/utils";

/** Figma how-it-works square mocks — 371×371 dot-grid canvas (8301:72996, 83101, 73126). */
export const PRODUCT_WIDGET_CANVAS = 371;

export const PRODUCT_WIDGET_DOT_GRID =
  "bg-[radial-gradient(#d1d1d1_1px,transparent_1px)] [background-size:20px_20px]";

/** Outer bordered square with dot-grid background. */
export function ProductWidgetFrame({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "border-grey-100 bg-grey-50 relative aspect-square overflow-hidden rounded-2xl border",
        PRODUCT_WIDGET_DOT_GRID,
        className
      )}
    >
      {children}
    </div>
  );
}

/** Scale a fixed 371×371 Figma canvas to the responsive square via SVG viewBox. */
export function ScaledProductWidgetCanvas({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <svg
      viewBox={`0 0 ${PRODUCT_WIDGET_CANVAS} ${PRODUCT_WIDGET_CANVAS}`}
      className="absolute inset-0 h-full w-full"
      aria-hidden
    >
      <foreignObject
        width={PRODUCT_WIDGET_CANVAS}
        height={PRODUCT_WIDGET_CANVAS}
      >
        <div
          {...{ xmlns: "http://www.w3.org/1999/xhtml" }}
          inert
          className="relative h-[371px] w-[371px] overflow-hidden"
        >
          {children}
        </div>
      </foreignObject>
    </svg>
  );
}
